const FILE_SIZES = ["Bytes", "KB", "MB", "GB", "TB"];

export function bytesToSize(bytes: number): string {
  if (bytes === undefined || bytes === null || isNaN(bytes) || bytes === 0) return "0 Byte";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const unit = FILE_SIZES[i];
  const value = Math.round(bytes / Math.pow(1024, i));
  return `${value} ${unit}`;
}
